// extracted by mini-css-extract-plugin
export default {"album":"Album_album__7yu8s","albumImg":"Album_albumImg__rkv2Q","albumTitle":"Album_albumTitle__u3Lsj","albumDescription":"Album_albumDescription__3aYm-"};